import styled from "styled-components";

import { Link } from "react-router-dom";

import { theme } from "../../../styles/theme";

export const Container = styled.div`
  height: 100vh;
  position: relative;
  overflow: hidden;
  display: flex;
  background-color: ${theme.colors.blue900};
  display: flex;
  justify-content: space-between;
`;

export const Main = styled.main`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

export const Footer = styled.footer`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
`;

export const TermsLink = styled(Link)`
  font-family: ${theme.font.poppins};
  font-weight: ${theme.font.normal};
  font-size: ${theme.font.sizes.normal};
  text-decoration: none;
  color: ${theme.colors.gray400};
`;
